module.exports = __webpack_public_path__ + "e4f70291d246beb455970b17e9fd14ce.pdf";